import { Host, h } from "@stencil/core";
import { remCalc } from "../../styles";
export class OhLoader {
    constructor() {
        this.size = `${remCalc(96)}rem`;
        this.noPadding = false;
    }
    render() {
        return (h(Host, { key: '60061aa89092d8d40bae4a29841fcb5655a1ad92' }, h("div", { key: '1295586233efab76a2465c169c5f0bf369bed9db', class: this.noPadding ? '' : 'loader__wrapper' }, h("div", { key: 'b84e23bb39029b0f2aa4ffd7ddcb68c2d22fbc14', class: "loader", style: {
                width: this.size,
                height: this.size,
            } }))));
    }
    static get is() { return "oh-loader"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["oh-loader.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["oh-loader.css"]
        };
    }
    static get properties() {
        return {
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "size",
                "reflect": false,
                "defaultValue": "`${remCalc(96)}rem`"
            },
            "noPadding": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "no-padding",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
//# sourceMappingURL=oh-loader.js.map
